module.exports = __webpack_public_path__ + "img/logo.c3b9705c.png";